export default {"src":"/_next/static/media/arrow-circle-left.65e64de0.svg","height":37,"width":37};